import { useRouter } from 'next/router';

const usePageNumber = ({
  paramName = 'page',
  fallback = 1,
}: {
  fallback: number;
  paramName?: string;
}): number => {
  const router = useRouter();
  const query = router.query[paramName];
  const queryStr = Array.isArray(query) ? query[0] : query;
  const pageNumber = isNaN(Number(queryStr)) ? fallback : Number(queryStr);

  return pageNumber;
};

export default usePageNumber;
